import React from "react";
import styled from "styled-components";
import CrossIcon from "@icons/CrossIcon.svg";
import CheckIcon from "@icons/FeatureCheckIcon.svg";
import { FontSize } from "@themes/Fonts";

const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    padding: 4px 8px;
    gap: 5px;
`;

const FeatureCheckIcon = styled(CheckIcon)<{ isHighlighted?: boolean }>`
    margin: 0 4px;
    fill: ${(props) => (props.isHighlighted ? "#FFFFFF" : props.theme.iconColor)};
`;

const FeatureCrossIcon = styled(CrossIcon)<{ isHighlighted?: boolean }>`
    margin: 0 4px;
    fill: ${(props) => (props.isHighlighted ? "#FFFFFF" : props.theme.iconColor)};
    scale: 0.8;
`;

const FeatureLabel = styled.span`
    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.small};
`;

const IconWrapper = styled.div<{ isHighlighted?: boolean }>`
    background-color: ${(props) => (props.isHighlighted ? "#41C603" : props.theme.backgroundSecondary)};
    height: 28px;
    width: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
interface FeatureItemProps {
    readonly featureName: string;
    readonly isHighlighted?: boolean;
    readonly iconType?: "check" | "cross";
}
export default function FeatureItem(props: FeatureItemProps) {
    return (
        <FeatureWrapper>
            <IconWrapper isHighlighted={props.isHighlighted}>
                {props.iconType === "cross" ? (
                    <FeatureCrossIcon
                        className={`upgrade-modal-feature-icon-cross`}
                        isHighlighted={props.isHighlighted}
                    />
                ) : (
                    <FeatureCheckIcon
                        className={`upgrade-modal-feature-icon-check`}
                        isHighlighted={props.isHighlighted}
                    />
                )}
            </IconWrapper>
            <FeatureLabel className={`upgrade-modal-feature-label`}>{props.featureName}</FeatureLabel>
        </FeatureWrapper>
    );
}
